import {
  C,
  P0,
  S,
  abs,
  dot,
  fillAt,
  frac,
  max,
  quad,
  rotPts,
  sq,
} from '../../geometry';

export const shroom = {
  name: 'Mushroom',
  colors: ['#E5484D', '#E3A008'],
  draw(m, t) {
    let tilt = 3 * S(t * 1.2),
      rx = 30,
      ry = 24,
      lift = 0,
      sp = 0,
      rate = 0.5,
      pose = P0();
    if (m === 'happy') {
      tilt = 7 * S(t * 6);
      sp = 0.7;
      rate = 1.3;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the cap keeps rocking on its stem while spores puff out from under the rim.
    if (m === 'thinking') {
      tilt = 9 * S(t * 1.6);
      sp = 1;
      rate = 0.75;
    }
    if (m === 'talking') lift = -3.5 * max(0, S(t * 10));
    if (m === 'surprised') {
      rx = 32;
      ry = 27;
      lift = -5;
      tilt = S(t * 20);
    }
    if (m === 'paused') {
      tilt = -11 + S(t * 0.7);
      ry = 20;
      lift = 3;
      pose.ty = 2;
    }
    const top = 56 + lift;
    const dome = [...Array(13)].map((_, k) => {
      const a = Math.PI + (k / 12) * Math.PI;
      return [50 + rx * C(a), top + ry * S(a)];
    });
    const cap = rotPts(
      [
        ...dome,
        ...quad([50 + rx, top], [50, top + 7], [50 - rx, top], 5).slice(1),
      ],
      50,
      top + 2,
      tilt
    );
    const spores = [0, 1, 2].map((i) => {
      const f = frac(t * rate + i / 3),
        side = i === 1 ? 1 : -1,
        x = 50 + side * (rx * 0.8 + f * 13) + 2 * S(f * 9 + i),
        y = top - 2 - f * 28;
      return {
        c: 'b',
        pts: dot(x, y),
        o: sp * S(Math.PI * f),
        snap: true,
        detail: true,
      };
    });
    const eye = rotPts([[50, top - 11]], 50, top + 2, tilt)[0];
    return {
      strokes: [
        { c: 'b', pts: sq(50, 72 + lift / 2, 9, 13 - lift / 2, 3), n: 24 },
        { c: 'a', pts: cap, n: 30 },
        ...spores,
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1),
};
